import calculator from './calculator';
import { combineReducers } from 'redux';

export const namPersonalLoansCalculator = combineReducers({
  calculator,
});
